import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { format } from 'date-fns'
import { DatePicker as DatePickerDS } from '@jisr-hr/design-system'
import { isRtl } from 'utils/uiHelpers'

const DatePicker = ({
  meta: { error, touched },
  input: { onChange, value, onBlur },
  onChangeAction,
  dateFormat,
  withFullDate,
  isCustomError,
  label,
  testId,
  ...rest
}) => (
  <DatePickerDS
    status={error && touched && 'error'}
    statusMessage={error}
    events={[]}
    {...rest}
    data-testid={testId}
    selected={value && new Date(value)}
    label={label && I18n.t(label)}
    popperPlacement="auto"
    locale={isRtl ? 'ar' : 'en'}
    onChange={(_, data) => {
      let formattedDate = data
      if (data) formattedDate = format(new Date(data), dateFormat)
      if (withFullDate) {
        onChange(data)
      } else {
        onChange(formattedDate)
      }
      if (onChangeAction) {
        onChangeAction(formattedDate, data)
      }
      onBlur()
    }}
  />
)

DatePicker.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  onChangeAction: PropTypes.func,
  dateFormat: PropTypes.string,
  testId: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
  placeholderText: PropTypes.string,
  withFullDate: PropTypes.bool,
  isCustomError: PropTypes.bool,
}

DatePicker.defaultProps = {
  dateFormat: 'yyyy-MM-dd',
  placeholderText: I18n.t('select_date'),
  size: 'large',
}

export default DatePicker
